import {createSelector} from "@ngrx/store";
import {IReportFillRateState} from "../../state/reports/reports-insights.state";
import {IAppState} from "../../state/app.state";
import {IReportsDataState, IReportsInsightsState} from "../../state/reports/reports.state";

/*

export const selectAuthenticatedUser = createSelector(
  (state: IAppState) => state.authenticatedUser,
  (state: IAuthenticatedUserState) => state.user
);

 */
export const selectFillRate = createSelector(
  (state: IAppState) => state.reports.insights,
  (state: IReportsInsightsState) => state.reportFillRate
);

export const selectStockRotation = createSelector(
  (state: IAppState) => state.reports.insights,
  (state: IReportsInsightsState) => state.reportStockRotation
);
